export default () => 'Settings – Conjugr8'
